/* istanbul ignore file */
import { appReducer, initialAppState } from 'store/reducer/app';
import { authReducer, initialAuthState } from 'store/reducer/auth';
import { initialSummaryState, summaryReducer } from 'store/reducer/summary';
import { copilotReducer, initialCopilotState } from './copilot';
import { featureFlagsReducer, initialFeatureFlagsState } from './featureFlags';
import { initialSnomedState, snomedReducer } from './snomed';
import { initialTemplatesState, templatesReducer } from './templates';
import { initialToolbarState, toolbarReducer } from './toolbar';
import { initialTranscriptionState, transcriptionReducer } from './transcription';
import walletReducer, { initialWalletState } from './wallet';
/* eslint-disable @typescript-eslint/no-explicit-any */

export const rootState = {
  app: initialAppState,
  auth: initialAuthState,
  summary: initialSummaryState,
  transcription: initialTranscriptionState,
  featureFlags: initialFeatureFlagsState,
  toolbar: initialToolbarState,
  snomed: initialSnomedState,
  copilot: initialCopilotState,
  templates: initialTemplatesState,
  wallet: initialWalletState,
};

const combineReducers = (reducers: any) => (state: any, action: any) =>
  Object.keys(reducers).reduce(
    (prevState, key) => ({
      ...prevState,
      [key]: reducers[key](prevState[key], action),
    }),
    state,
  );

export const rootReducer = combineReducers({
  app: appReducer,
  auth: authReducer,
  transcription: transcriptionReducer,
  summary: summaryReducer,
  featureFlags: featureFlagsReducer,
  toolbar: toolbarReducer,
  snomed: snomedReducer,
  copilot: copilotReducer,
  templates: templatesReducer,
  wallet: walletReducer,
});
